import { stagePostForm, withQuery } from "@/shared/api";

/** Сдаваемое устройство после ответа на вопрос о состоянии */
export interface AnsweredDevice {
    deviceId: string;
    /** Грейд по ответу, например "A+" */
    grade: string;
    gradeNormalized: string;
    /** Цена выкупа с учётом ответа, например "97000.00" */
    price: string;
    currency: string;
    additionalDiscountValue: number;
    instantAmount: number;
}

interface SendStatusAnswerResponse {
    device: AnsweredDevice;
    imgCid: string;
}

/**
 * Ответить на вопрос о состоянии устройства
 * 8.1 документация ru 1.0.5
 */
export async function apiSendStatusAnswer(payload: {
    deviceId: string;
    token: string;
    lang: string;
    questionId: string;
    /** Идентификатор выбранного варианта ответа */
    c: string;
}): Promise<AnsweredDevice> {
    // As in v2, the answer goes in the query string and the body stays empty
    const response = await stagePostForm<SendStatusAnswerResponse>(
        withQuery("/api/tin/v1/site/quest/question", { ...payload, ans: "" }),
    );
    return response.device;
}
